import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { DEFAULT_SITE_CONTENT } from "@/lib/defaultSiteContent";
const SiteContentContext = createContext({
  content: DEFAULT_SITE_CONTENT,
  refresh: async () => {},
});

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_SITE_CONTENT);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site-content");
      if (r.data?.site_content) setContent(r.data.site_content);
    } catch (_) {
      /* marad a default */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}

/** Nav / footer link: hash → <a href>, route → React Router path */
export function siteNavHref(link) {
  if (!link) return "/";
  return link.path || "/";
}

export function interpolateTemplate(template, vars = {}) {
  if (!template) return "";
  return String(template).replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ""));
}
